import { Schema } from '@blade/std-lib'

export class SubstackResizePostMessage extends Schema.Class<SubstackResizePostMessage>(
  'SubstackResizePostMessage',
)({
  iframeHeight: Schema.Number,
}) {
  static decode = Schema.decodeUnknownOption(SubstackResizePostMessage)
}
